<style>
/* Set the page size to A4 and the orientation to landscape */
@page {
  size: A4 landscape;
}

@media print {
  /* Force content to fit on one page */
  body {
    margin: 0;
    padding: 0;
    page-break-after: always;
  }

  /* Prevent additional page breaks */
  .last-page {
    page-break-after: avoid;
  }
}
</style>

<template>
  <div>
    <table style="border: none; width: 749.6pt; border-collapse: collapse">
      <tbody>
        <tr>
          <td
            rowspan="2"
            style="
              width: 118.8pt;
              padding: 0cm 5.4pt;
              height: 14.2pt;
              vertical-align: top;
            "
          >
            <table
              style="border: none; width: 749.6pt; border-collapse: collapse"
            >
              <tbody>
                <tr>
                  <td
                    rowspan="2"
                    style="
                      width: 118.8pt;
                      padding: 0cm 5.4pt;
                      height: 14.2pt;
                      vertical-align: top;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <span
                        style="
                          font-size: 11px;
                          font-family: 'Arial', sans-serif;
                        "
                        ><img
                          src="data:image/png;base64,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"
                          style="width: 80px"
                      /></span>
                    </p>
                  </td>
                  <td
                    style="
                      width: 630.8pt;
                      padding: 0cm 5.4pt;
                      height: 14.2pt;
                      vertical-align: bottom;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: justify;
                      "
                    >
                      <strong
                        ><span
                          style="font-family: 'Arial', sans-serif; color: red"
                          >{{ data.sales_return.Code }}</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      width: 630.8pt;
                      padding: 0cm 5.4pt;
                      height: 12.95pt;
                      vertical-align: top;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: justify;
                      "
                    >
                      <strong
                        ><span style="font-family: 'Arial', sans-serif"
                          >SURAT PENARIKAN BARANG RETUR (SPBR)</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: justify;
                      "
                    >
                      <strong
                        ><span style="font-family: 'Arial', sans-serif"
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              &nbsp;
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              <strong
                ><span style="font-size: 11px; font-family: 'Arial', sans-serif"
                  >&nbsp; &nbsp;</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
                line-height: 150%;
              "
            >
              <strong
                ><span
                  style="
                    font-size: 13px;
                    line-height: 150%;
                    font-family: 'Arial', sans-serif;
                  "
                  >Nama <em>Customer</em>&nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp;&nbsp;: {{ data.customer.name }}</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
                line-height: 150%;
              "
            >
              <strong
                ><em
                  ><span
                    style="
                      font-size: 13px;
                      line-height: 150%;
                      font-family: 'Arial', sans-serif;
                    "
                    >Customer Code</span
                  ></em
                ></strong
              ><strong
                ><span
                  style="
                    font-size: 13px;
                    line-height: 150%;
                    font-family: 'Arial', sans-serif;
                  "
                  >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;:
                  {{ data.customer.code_external }}</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
                line-height: 150%;
              "
            >
              <strong
                ><span
                  style="
                    font-size: 13px;
                    line-height: 150%;
                    font-family: 'Arial', sans-serif;
                  "
                  >Tanggal Penarikan &nbsp; &nbsp; &nbsp;:
                  {{
                    convertUTCtoLocalDate(data.sales_return.PickupDate)
                  }}</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              <strong
                ><span style="font-size: 13px; font-family: 'Arial', sans-serif"
                  >&nbsp;</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              <strong
                ><span style="font-size: 11px; font-family: 'Arial', sans-serif"
                  >&nbsp;</span
                ></strong
              >
            </p>
            <table
              style="
                border: none;
                width: 814.85pt;
                margin-left: 5.65pt;
                border-collapse: collapse;
              "
            >
              <tbody>
                <tr>
                  <td
                    rowspan="2"
                    style="
                      width: 27.35pt;
                      border: solid windowtext 1pt;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >No.</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    rowspan="2"
                    style="
                      width: 142.5pt;
                      border: solid windowtext 1pt;
                      border-left: none;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >Nama Barang (Dari SO Retur)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    rowspan="2"
                    style="
                      width: 3cm;
                      border: solid windowtext 1pt;
                      border-left: none;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >No. SKU (Dari SO Retur)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    rowspan="2"
                    style="
                      width: 99.25pt;
                      border: solid windowtext 1pt;
                      border-left: none;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >No. Produksi (Batch)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    rowspan="2"
                    style="
                      width: 1cm;
                      border: solid windowtext 1pt;
                      border-left: none;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >Qty (Dari SO Retur)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    rowspan="2"
                    style="
                      width: 92.15pt;
                      border: solid windowtext 1pt;
                      border-left: none;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >No. Faktur (referensi AR invoice)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    rowspan="2"
                    style="
                      width: 70.85pt;
                      border-top: solid windowtext 1pt;
                      border-left: none;
                      border-bottom: solid black 1pt;
                      border-right: solid windowtext 1pt;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >Harga (Dari SO Retur)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    rowspan="2"
                    style="
                      width: 134.65pt;
                      border: solid windowtext 1pt;
                      border-left: none;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >Alasan Retur (Dari SO Retur)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    colspan="2"
                    style="
                      width: 134.7pt;
                      border: solid windowtext 1pt;
                      border-left: none;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >Status SKU (manual)</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      width: 70.9pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      background: #d9d9d9;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >Good Stock</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 63.8pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >Bad Stock</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr
                  v-for="(value, index) in data.sales_return_lines"
                  :key="index"
                >
                  <td
                    style="
                      width: 27.35pt;
                      border: solid windowtext 1pt;
                      border-top: none;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: right;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >{{ index + 1 }}</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 142.5pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >{{ value.ItemName }}</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 3cm;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >{{ value.ItemCode }}</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 99.25pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: right;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >{{ value.Batch }}</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 1cm;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: right;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >{{ value.Quantity }}</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 92.15pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >{{ data.invoice_code }}</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 70.85pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: right;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >{{ numberFormat(value.Price) }}</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 134.65pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 13px;
                            font-family: 'Arial', sans-serif;
                            color: black;
                          "
                          >{{ value.Reason }}</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 70.9pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <br />
                  </td>
                  <td
                    style="
                      width: 63.8pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 25.5pt;
                    "
                  >
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              <strong
                ><span style="font-size: 11px; font-family: 'Arial', sans-serif"
                  >&nbsp;</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              <strong
                ><span style="font-size: 11px; font-family: 'Arial', sans-serif"
                  >&nbsp;</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              <strong
                ><span style="font-size: 11px; font-family: 'Arial', sans-serif"
                  >&nbsp;</span
                ></strong
              >
            </p>
            <table
              style="
                margin-left: 5.4pt;
                border-collapse: collapse;
                border: none;
              "
            >
              <tbody>
                <tr>
                  <td
                    style="
                      width: 4cm;
                      border: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 18.45pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Dibuat Oleh,</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    colspan="2"
                    style="
                      width: 248.1pt;
                      border: solid windowtext 1pt;
                      border-left: none;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 18.45pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Disetujui Oleh,</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    colspan="2"
                    style="
                      width: 233.85pt;
                      border: solid windowtext 1pt;
                      border-left: none;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 18.45pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Diserahkan Oleh,</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 120.5pt;
                      border: solid windowtext 1pt;
                      border-left: none;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 18.45pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Diterima Oleh,</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      width: 4cm;
                      border-right: 1pt solid windowtext;
                      border-bottom: 1pt solid windowtext;
                      border-left: 1pt solid windowtext;
                      border-image: initial;
                      border-top: none;
                      padding: 0cm 5.4pt;
                      vertical-align: top;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >Salesman / Driver</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >( &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; )</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 120.5pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: 1pt solid windowtext;
                      border-right: 1pt solid windowtext;
                      padding: 0cm 5.4pt;
                      vertical-align: top;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >Supervisor Salesman / DSS</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >( &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; )</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 127.6pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: 1pt solid windowtext;
                      border-right: 1pt solid windowtext;
                      padding: 0cm 5.4pt;
                      vertical-align: top;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >BM / OM</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >( &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; )</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 120.45pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: 1pt solid windowtext;
                      border-right: 1pt solid windowtext;
                      padding: 0cm 5.4pt;
                      vertical-align: top;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >Customer</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >( &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; )</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 4cm;
                      border-top: none;
                      border-left: none;
                      border-bottom: 1pt solid windowtext;
                      border-right: 1pt solid windowtext;
                      padding: 0cm 5.4pt;
                      vertical-align: top;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >Driver</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >( &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; )</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 120.5pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: 1pt solid windowtext;
                      border-right: 1pt solid windowtext;
                      padding: 0cm 5.4pt;
                      vertical-align: top;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >PIC Logistic</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><em
                          ><span
                            style="
                              font-size: 11px;
                              font-family: 'Arial', sans-serif;
                            "
                            >&nbsp;</span
                          ></em
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                        text-align: center;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >( &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; )</span
                        ></strong
                      >
                    </p>
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >&nbsp;</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      width: 4cm;
                      border: solid windowtext 1pt;
                      border-top: none;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15.65pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Tanggal:</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 120.5pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15.65pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Tanggal:</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 127.6pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15.65pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Tanggal:</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 120.45pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15.65pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Tanggal:</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 4cm;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15.65pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Tanggal:</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td
                    style="
                      width: 120.5pt;
                      border-top: none;
                      border-left: none;
                      border-bottom: solid windowtext 1pt;
                      border-right: solid windowtext 1pt;
                      padding: 0cm 5.4pt 0cm 5.4pt;
                      height: 15.65pt;
                    "
                  >
                    <p
                      style="
                        margin: 0cm;
                        font-size: 16px;
                        font-family: 'Times New Roman', serif;
                      "
                    >
                      <strong
                        ><span
                          style="
                            font-size: 11px;
                            font-family: 'Arial', sans-serif;
                          "
                          >Tanggal:</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              <strong
                ><span style="font-size: 11px; font-family: 'Arial', sans-serif"
                  >&nbsp;</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
                line-height: 150%;
              "
            >
              <strong
                ><u
                  ><span
                    style="
                      font-size: 11px;
                      line-height: 150%;
                      font-family: 'Arial', sans-serif;
                    "
                    >Keterangan:</span
                  ></u
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
                line-height: 150%;
              "
            >
              <strong
                ><span
                  style="
                    font-size: 11px;
                    line-height: 150%;
                    font-family: 'Arial', sans-serif;
                  "
                  >Rangkap 1: Disimpan oleh <em>Adm.AR</em></span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
                line-height: 150%;
              "
            >
              <strong
                ><span
                  style="
                    font-size: 11px;
                    line-height: 150%;
                    font-family: 'Arial', sans-serif;
                  "
                  >Rangkap 2: Diserahkan ke
                  <em>Adm.Gudang (3PL)/Adm.Sales (SDN)</em>&nbsp;</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
                line-height: 150%;
              "
            >
              <strong
                ><span
                  style="
                    font-size: 11px;
                    line-height: 150%;
                    font-family: 'Arial', sans-serif;
                  "
                  >Rangkap 3: Disimpan oleh <em>Customer</em></span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
                line-height: 150%;
              "
            >
              <strong
                ><span
                  style="
                    font-size: 11px;
                    line-height: 150%;
                    font-family: 'Arial', sans-serif;
                  "
                  >&nbsp;</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              <strong
                ><span style="font-size: 11px; font-family: 'Arial', sans-serif"
                  >&nbsp;</span
                ></strong
              >
            </p>
            <p
              style="
                margin: 0cm;
                font-size: 16px;
                font-family: 'Times New Roman', serif;
              "
            >
              <strong
                ><span style="font-size: 11px; font-family: 'Arial', sans-serif"
                  >&nbsp;</span
                ></strong
              >
            </p>
          </td>
          <td
            style="
              width: 630.8pt;
              padding: 0cm 5.4pt;
              height: 14.2pt;
              vertical-align: bottom;
            "
          >
            <br />
          </td>
        </tr>
      </tbody>
    </table>
    <p
      style="
        margin: 0cm;
        font-size: 16px;
        font-family: 'Times New Roman', serif;
      "
    >
      <br />
    </p>
  </div>
</template>

<script>
import { convertUTCtoLocalDate, numberFormat } from "@/utils/helper";

export default {
  data() {
    return {
      data: null,
    };
  },
  methods: {
    numberFormat,
    convertUTCtoLocalDate,
    getData() {
      // from query id
      const id = this.$route.query.id;
      console.log("id", id)

      // get data from api
      this.$vs.loading();
      this.$http
        .get(`api/v2/sales-return-management/${id}/export/pdf`)
        .then((resp) => {
          this.$vs.loading.close();
          this.data = resp.data;

          setTimeout(() => {
            window.print();
          }, 1000);
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: error.message,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
